import React from "react";
import { List, Spin, Empty, Typography, Button, Tooltip, Badge } from "antd";
import { PlusOutlined, UserOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { ButtonItem, InputItem } from "../../../../Components/Items";
import TagFase from "./TagFase";
import TagRespuestaCliente from "./TagRespuestaCliente";
import { nombreDeUsuario } from "./nombreUsuario";
import { textoUltimoMensaje } from "./prefijoUltimoMensaje";
import AvisoHorario from "./AvisoHorario";
import { SOPORTE_TEMA, HORARIO_ATENCION_CORTO } from "./fasesSoporte";

const { Text } = Typography;

const TOPE_LISTA = 100;

const TicketItem = ({ ticket, onSelect, mostrarReportero, esPropio, usuarioId, modoSoporte, modoPeticiones, anchoTexto }) => {
  const noLeidos =
    (modoSoporte ? ticket.noLeidosSoporte : modoPeticiones ? ticket.noLeidosRevisor : ticket.noLeidosCliente) || 0;

  return (
    <List.Item onClick={() => onSelect(ticket)} style={{ cursor: "pointer", padding: "10px 14px" }}>
      <List.Item.Meta
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Text strong style={{ color: SOPORTE_TEMA.textPrimary }}>
              {ticket.folio} — {ticket.titulo}
              {noLeidos > 0 && (
                <Badge
                  count={noLeidos}
                  overflowCount={99}
                  style={{ backgroundColor: SOPORTE_TEMA.primario, marginLeft: 6 }}
                />
              )}
            </Text>
            {ticket.ultimoMensajeFecha && (
              <Text style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary, flexShrink: 0, marginLeft: 6 }}>
                {moment(ticket.ultimoMensajeFecha).format("DD/MM HH:mm")}
              </Text>
            )}
          </div>
        }
        description={
          <>
            {/* En la bandeja de soporte, de qué empresa viene el reporte. */}
            {modoSoporte && (
              <Text ellipsis style={{ fontSize: 11, maxWidth: anchoTexto, color: SOPORTE_TEMA.primarioFuerte, display: "block" }}>
                {ticket.empresaId?.nombre || "Sin empresa"}
              </Text>
            )}
            <Text ellipsis style={{ fontSize: 12, maxWidth: anchoTexto, color: SOPORTE_TEMA.textSecondary, display: "block" }}>
              {textoUltimoMensaje(ticket, usuarioId)}
            </Text>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
              <TagFase fase={ticket.fase} />
              <TagRespuestaCliente respuesta={ticket.respuestaCliente} />
              {mostrarReportero && (
                <span style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary }}>
                  <UserOutlined style={{ fontSize: 10, marginRight: 3 }} />
                  {esPropio ? "Tú" : nombreDeUsuario(ticket.usuarioId, "Otro usuario")}
                </span>
              )}
            </div>
          </>
        }
      />
    </List.Item>
  );
};

const HeaderAcciones = ({ onNuevoTicket, modoSoporte, modoPeticiones, total, busqueda, onBuscar, buscando }) => (
  <div style={{ borderBottom: `1px solid ${SOPORTE_TEMA.border}`, flexShrink: 0 }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "6px 12px",
      }}
    >
      <span style={{ fontSize: 12, color: SOPORTE_TEMA.textSecondary, fontWeight: 500 }}>
        {modoSoporte
          ? `${buscando ? "Resultados" : "Reportes abiertos"}${total ? ` (${total})` : ""}`
          : modoPeticiones
            ? `Peticiones por revisar${total ? ` (${total})` : ""}`
            : "Mis tickets"}
      </span>
      {!modoSoporte && !modoPeticiones && (
        <Tooltip title="Levantar un ticket">
          <Button
            type="text"
            size="small"
            icon={<PlusOutlined />}
            onClick={onNuevoTicket}
            style={{ color: SOPORTE_TEMA.primarioFuerte }}
          />
        </Tooltip>
      )}
    </div>
    {!modoSoporte && !modoPeticiones && (
      <div style={{ padding: "0 12px 8px" }}>
        <AvisoHorario compacto texto={`Atención: ${HORARIO_ATENCION_CORTO}`} />
      </div>
    )}
    {/* Solo soporte: su bandeja está paginada y tiene reportes de todas las
        empresas. La búsqueda mira TODAS las fases, no solo las activas. */}
    {modoSoporte && onBuscar && (
      <div style={{ padding: "0 12px 8px" }}>
        <InputItem
          allowClear
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          placeholder="Buscar empresa, folio o Jira..."
          value={busqueda}
          onChange={(e) => onBuscar(e.target.value)}
          style={{ borderRadius: 4 }}
        />
      </div>
    )}
  </div>
);

const ListaTicketsSoporte = ({
  tickets,
  loading,
  onSelect,
  onNuevoTicket,
  mostrarReportero,
  usuarioId,
  modoSoporte,
  modoPeticiones,
  header: headerPropio,
  pieDeLista,
  anchoTexto = 230,
  busqueda,
  onBuscar,
  buscando,
  totalRecords,
  hayMas,
  cargandoMas,
  onCargarMas,
}) => {
  const header =
    headerPropio !== undefined ? (
      headerPropio
    ) : (
      <HeaderAcciones
        onNuevoTicket={onNuevoTicket}
        modoSoporte={modoSoporte}
        modoPeticiones={modoPeticiones}
        // Con la bandeja paginada, tickets.length es solo lo cargado.
        total={modoSoporte ? totalRecords : tickets.length}
        busqueda={busqueda}
        onBuscar={onBuscar}
        buscando={buscando}
      />
    );

  const pie =
    pieDeLista !== undefined
      ? pieDeLista
      : hayMas && onCargarMas ? (
          <div style={{ textAlign: "center", padding: "8px 0" }}>
            <Button type="link" size="small" loading={cargandoMas} onClick={onCargarMas}>
              Cargar más
            </Button>
          </div>
        ) : modoSoporte && tickets.length >= TOPE_LISTA ? (
          <div style={{ textAlign: "center", padding: "8px 12px", fontSize: 11, color: SOPORTE_TEMA.textSecondary }}>
            Usa el buscador para encontrar reportes más viejos.
          </div>
        ) : undefined;

  if (loading) {
    return (
      <>
        {header}
        <div style={{ textAlign: "center", padding: 30 }}>
          <Spin />
        </div>
      </>
    );
  }

  if (!tickets.length) {
    return (
      <>
        {header}
        <div style={{ padding: 30 }}>
          {modoSoporte && buscando ? (
            <Empty description={`Sin resultados para "${busqueda}"`}>
              <Button type="link" size="small" onClick={() => onBuscar("")}>
                Limpiar búsqueda
              </Button>
            </Empty>
          ) : modoSoporte ? (
            <Empty description="No hay reportes pendientes de atender" />
          ) : modoPeticiones ? (
            <Empty description="Todo al día, no hay peticiones por revisar" />
          ) : (
            <Empty description="Aún no has levantado ningún ticket">
              <ButtonItem type="primary" naranja icon={<PlusOutlined />} onClick={onNuevoTicket}>
                Levantar un ticket
              </ButtonItem>
            </Empty>
          )}
        </div>
      </>
    );
  }

  return (
    <>
      {header}
      <List dataSource={tickets} rowKey="_id" loadMore={pie} renderItem={(ticket) => (
        <TicketItem
          ticket={ticket}
          onSelect={onSelect}
          mostrarReportero={mostrarReportero}
          esPropio={String(ticket.usuarioId?._id || ticket.usuarioId) === String(usuarioId)}
          usuarioId={usuarioId}
          modoSoporte={modoSoporte}
          modoPeticiones={modoPeticiones}
          anchoTexto={anchoTexto}
        />
      )} />
    </>
  );
};

export default ListaTicketsSoporte;
